import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIdealComponent } from './simple-icons-ideal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIdealComponent ],
    exports:      [ SimpleIconsIdealComponent ],
    bootstrap:    []
})
export class SimpleIconsIdealModule {}
